import { render, staticRenderFns } from "./CategoryAttributesList.vue?vue&type=template&id=d57850f2&scoped=true&"
import script from "./CategoryAttributesList.vue?vue&type=script&lang=js&"
export * from "./CategoryAttributesList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAttributesList.vue?vue&type=style&index=0&id=d57850f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57850f2",
  null
  
)

export default component.exports